import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import isEmpty from 'lodash/isEmpty';

import * as actions from '../../../../inspection/inspection.actions';

import { withStyles } from 'material-ui/styles';

import Dialog, { DialogContent } from 'material-ui/Dialog';

import IconButton from 'material-ui/IconButton';
import DeleteIcon from 'material-ui-icons/Delete';
import ButtonBase from 'material-ui/ButtonBase';
import Typography from 'material-ui/Typography';

const styles = theme => ({
  paper: {
    maxWidth: 'unset',
  },
  dialogContent: {
    padding: '0 !important',
  },
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    paddingBottom: theme.spacing.unit * 2,
    borderBottom: '1px solid rgba(155,155,155,0.15)',
    '&:first-of-type': {
      borderTop: '1px solid rgba(155,155,155,0.15)',
    },
  },
  header: {
    width: '100%',
    minHeight: 48,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  error: {
    color: theme.palette.error['A400'],
  },
  flex: {
    flex: 1,
  },
  input: {
    width: '0.1px',
    height: '0.1px',
    opacity: '0',
    overflow: 'hidden',
    position: 'absolute',
    zIndex: -1,
  },
  button: {
    width: 280,
    minHeight: 93,
    textOverflow: 'ellipsis',
    whiteSpace: 'unset',
    cursor: 'pointer',
    //overflow: 'hidden',
  },
  padding: {
    marginLeft: theme.spacing.unit,
    marginTop: theme.spacing.unit,
  },
  image: {
    width: '100%',
    height: 'auto',
    lineHeight: 0,
    fontSize: 0,
    '& > img': {
      width: '100%',
      height: 'auto',
    },
  },
  placeholder: {
    width: '100%',
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    padding: theme.spacing.unit * 3,
    textAlign: 'center',
    backgroundColor: theme.palette.common.faintBlack,
  },
});

class ImageWidget extends Component {
  state = {
    isUploading: false,
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  onChange = event => {
    const file = event.target.files[0]; // FileList object

    if (!file || !file.type.match('image.*')) {
      return;
    }

    const { uploadImage, formContext: { _id } } = this.props;
    let formData = new FormData();
    formData.append('file', file);
    uploadImage(_id, formData)
      .then(action => {
        this.props.onChange(action.response.id);
      })
      .catch(error => {});
  };

  onClear = event => {
    this.props.onChange('');
  };

  render() {
    const { classes, formContext, schema, errorSchema, options, name, value, id, readonly, online } = this.props;
    const title = schema.title === undefined ? name : schema.title;
    const { validatorKey } = options;
    const hasError = !isEmpty(errorSchema);
    const formControlState = formContext.formControlStates[validatorKey];
    const shouldShowError = hasError && (formControlState.dirty || formContext.shouldStrictValidate);
    const { imageFileExtension, imageOriginalPrefix, imagePath, imageThumbnailPrefix } = formContext;
    const thumbnailUrl = !value ? null : `${imagePath}${imageThumbnailPrefix}${value}${imageFileExtension}`;

    const imageUrl = !value ? null : `${imagePath}${imageOriginalPrefix}${value}${imageFileExtension}`;

    const canEdit = !readonly && formContext.formStatus === 'editable' && online;
    const onlineError =
      'Kuvien lisäämiseen tarvitaan internet-yhteys. Voit tallentaa kuvat puhelimen galleriaan ja lisätä ne myöhemmin.';

    const addPictureLabel = formContext.formSchema.id === "wagri.inspection.wagri" ? 'Vali pilt seadmest' : 'Lisää kuva';
    const addPictureFromCamLabel = formContext.formSchema.id === "wagri.inspection.wagri" ? 'Tee pilt kaameraga' : 'Lisää kuva kamerasta';

    const hasCamera = window.Modernizr && window.Modernizr.capture;

    const input = (
      <div className={classes.container}>
        {!online && <Typography className={classes.error}>{onlineError}</Typography>}
        <header className={classes.header}>
          <Typography
            className={classnames({
              [classes.error]: shouldShowError,
            })}
          >
            {title}
          </Typography>

          <div className={classes.flex} />
          {canEdit && (
            <IconButton disabled={!value} onClick={this.onClear} className={classes.trashIcon}>
              <DeleteIcon />
            </IconButton>
          )}
        </header>
        {value ? (
          <ButtonBase component="div" focusRipple className={classes.button} onClick={this.handleClickOpen}>
            <div className={classes.image}>
              <img src={thumbnailUrl} alt="" />
            </div>
          </ButtonBase>
        ) : (
          canEdit && (
            <div>
              <input
                accept="image/*"
                className={classes.input}
                id={id}
                name={id}
                type="file"
                onChange={this.onChange}
              />

              <input
                accept="image/*"
                capture="environment"
                className={classes.input}
                id={id + '_cam'}
                name={id + '_cam'}
                type="file"
                onChange={this.onChange}
              />

              <ButtonBase htmlFor={id} component="label" focusRipple className={classes.button}>
                {value && (
                  <div className={classes.image}>
                    <img src={thumbnailUrl} alt="" />
                  </div>
                )}
                {!value && (
                  <div className={classes.placeholder}>
                    <Typography type="caption">{addPictureLabel}</Typography>
                  </div>
                )}
              </ButtonBase>
              {hasCamera && (
                <div>
                  <div className={classes.padding} />
                  <ButtonBase htmlFor={id + '_cam'} component="label" focusRipple className={classes.button}>
                    {value && (
                      <div className={classes.image}>
                        <img src={thumbnailUrl} alt="" />
                      </div>
                    )}
                    {!value && (
                      <div className={classes.placeholder}>
                        <Typography type="caption">{addPictureFromCamLabel}</Typography>
                      </div>
                    )}
                  </ButtonBase>
                </div>
              )}
            </div>
          )
        )}
        <Dialog
          open={this.state.open}
          onRequestClose={this.handleRequestClose}
          classes={{
            paper: classes.paper,
          }}
        >
          <DialogContent className={classes.dialogContent}>
            <div className={classes.image}>
              <img src={imageUrl} alt="" />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );

    return input;
  }
}

ImageWidget.propTypes = {
  classes: PropTypes.object.isRequired,
  formContext: PropTypes.object.isRequired,
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  uploadImage: PropTypes.func.isRequired,
  schema: PropTypes.object.isRequired,
  errorSchema: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
  id: PropTypes.string,
  readonly: PropTypes.bool,
  online: PropTypes.bool,
};
const mapStateToProps = state => {
  const online = state.offline.online;
  return { online };
};
export default connect(mapStateToProps, actions)(withStyles(styles)(ImageWidget));



// WEBPACK FOOTER //
// ./src/modules/common/components/form/widgets/ImageWidget.js